<ng-template #itemdetails let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title"><b>{{ item_details.stockid }}</b><span [innerHTML]="item_details.name"></span> &nbsp;&nbsp;&nbsp;
			<a *ngIf="config.env.package == 'tires' || (config.env.package == 'beauty'  && !issalesman)" [routerLink]="'/inventory/view/'+item_details.stockid"><i class="pointer fa fa-edit"></i></a>
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="row">
			<mat-card class="tire-card " *ngIf="item_details">
				<mat-card-title-group>
					<mat-card-title>
						<h3 [innerHTML]="cleanAndFormatHTML(item_details.descriptions.name)"></h3>
						<section class="section-small" [innerHTML]="cleanAndFormatHTML(item_details.descriptions.description)"></section>
					</mat-card-title>
					<div class="tire-image">
						<div class="tire-image-container" *ngIf="itemImageSrc(item_details)">
							<img mat-card-lg-image [src]="itemImageSrc(item_details)" class="img img-responsive large-thumb" alt="" data-eager>
						</div>
					</div>
				</mat-card-title-group>
				<mat-card-content class="padding-0">
					<mat-tab-group #tabPanel mat-align-tabs="start" color="accent">
						<mat-tab label="Overview">
							<div class="row">
								<div class="col-md-6">
									Features:<br>
									<span [innerHTML]="cleanAndFormatHTML(item_details.descriptions.features)"></span>
								</div>
								<div class="col-md-6">
									Benefits:<br>
									<span [innerHTML]="cleanAndFormatHTML(item_details.descriptions.benefits)"></span>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Attributes">
							<div class="row">
								<div class="col-md-6">
									<ul class="spec-list" *ngFor="let a of item_details.additional; let i = index">
										<li *ngIf="!(i % 2)">
											<div class="spec-label"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
								<div class="col-md-6">
									<ul class="spec-list" *ngFor="let a of item_details.additional; let i = index">
										<li *ngIf="i % 2">
											<div class="spec-label ml-1"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Specs">
							<!-- <mat-form-field appearance="standard" *ngIf="!addingattribute" class="text-right">
								<mat-label>Search Attributes</mat-label>
								<input type="text" class="text-right m-0 p-0" matInput (input)="searchAttributes($event.target.value)" />
							</mat-form-field> -->

							<div class="row">
								<div class="col-6">
									<ul class="spec-list" *ngFor="let a of item_details.specs; let i = index">
										<li *ngIf="!(i % 2)">
											<div class="spec-label"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
								<div class="col-6">
									<ul class="spec-list" *ngFor="let a of item_details.specs; let i = index">
										<li *ngIf="i % 2">
											<div class="spec-label ml-1"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
							</div>
						</mat-tab>
					</mat-tab-group>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #mmmodal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ promo.itemdesc.stockid }} <span>{{promo.itemdesc.description }}</span></h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark row m-0 p-0 mm-modal-body" [class.mm-modal-body--substituting]="showSubstitution">

		<div class="m-0 p-0 mm-modal-main" [ngClass]="{'col-12': !mmSidePanel, 'col-lg-5': mmSidePanel && showSubstitution, 'col-lg-9': mmSidePanel && !showSubstitution}">
			<div class="alert alert-warning py-2 mb-0 mx-2 mt-2" *ngIf="promo?.has_discontinued_intro" role="alert">
				This promo includes discontinued item(s). Verify before adding to the order.
			</div>
			<div class="row p-2">
				<div class="col-md-9">
					<div class="promo-item-description">
						<p class="stock-id">{{ promo.itemdesc.stockid }}</p>
						<p class="description">{{ promo.itemdesc.description }}</p>
					</div>
					<details class="mm-intros-collapse mm-intros-collapse--legacy">
						<summary class="mm-intros-collapse__summary">
							<span class="mm-intros-collapse__label">Included items</span>
							<i class="fa fa-angle-down mm-intros-collapse__chev" aria-hidden="true"></i>
						</summary>
						<div class="mm-intros-collapse__body">
							<ul class="list-group">
								<ng-container *ngFor="let intro of promo.intros">
									<ng-container *ngIf="intro.type === '1' || intro.type === 1">
										<li class="list-group-item item-details-above" [class.border-warning]="intro.discontinued == 1 || intro.discontinued === '1'">
											<div class="item-description">
												<p>
													{{ intro.stockid }} - {{ intro.description }} ({{ intro.qty }} @ {{ intro.price | currency }})
													<span *ngIf="intro.discontinued == 1 || intro.discontinued === '1'" class="badge bg-danger ms-1">Discontinued</span>
												</p>
											</div>
										</li>
									</ng-container>
								</ng-container>
							</ul>
						</div>
					</details>
				</div>
				<div class="col-md-3 text-right">
					<mat-form-field appearance="outline">
						<mat-label>Qty</mat-label>
						<span matPrefix>#</span>
						<input matInput type="number" [(ngModel)]="promo.qty" (input)="setParent($event, promo)" class="text-right">
					</mat-form-field>
				</div>
			</div>

			<!-- {{ promo.descriptions | json }} <h4>PROMO {{ promo.description }} {{ ispromo.promo.price | currency }} </h4> -->
			<div class="promo-container" *ngIf="promo">		
				<h5 class="p-2">Promo Items</h5>

				<div class="row m-0 p-0">
					<div class="col-12 sticky-col">
						<button class="btn btn-primary float-right" [disabled] = "isCompleted(promo)"  (click)="addMM(promo)">Add To Order </button>
					</div>
					<div class="col-12">
						<mat-form-field appearance="outline">
							<mat-label>Scan to select</mat-label>
							<input matInput placeholder="Scan to select item..." value="" (keyup.enter)="searchPromos($event)">
						</mat-form-field>
					</div>
					<ng-container *ngFor="let intro of promo.intros">
						<div class="col-md-12" *ngIf="intro.type != '1'">
							<mat-accordion class="w-100">
											<mat-expansion-panel
												[expanded]="!isGroupCollapsed(intro, promo.intros)"
												(opened)="setGroupCollapsed(intro, false)"
												(closed)="setGroupCollapsed(intro, true)">
												<mat-expansion-panel-header>
													<mat-panel-title>
													<h4><b>{{ intro.name }} {{ intro.description }}</b></h4>
													</mat-panel-title>
													<ng-container *ngIf="intro.type === '1'; else typeDefault">
									<div class="intro-details">
										<div class="quantity-info">
											{{ intro.item }} - {{ intro.description }} ({{ intro.qty }} @ {{ intro.price | currency }})
										</div>
									</div>
								</ng-container>
								<ng-template #typeDefault>
									<div class="intro-details" [ngClass]="{'error': intro.error}">
										<div class="quantity-info">
											{{ intro.price }} <span [ngClass]="{'zero-quantity': (updateMMQty(intro) == 0) }">{{ intro.dsptype }} {{ updateMMQty(intro) }} / {{ intro.floor }}</span> {{ intro.price }} &nbsp;
										</div>
									</div>
								</ng-template>
							</mat-expansion-panel-header>

							<div class="mt-2 mb-2">
								<mat-form-field appearance="outline">
									<mat-label>Search Mix & Match...</mat-label>
									<input tabindex="1" matInput value="" [(ngModel)]="intro.searchQuery" (input)="filterItems(intro)" appCollapseKeyboard>
									<span matSuffix>
										<button tabindex="-1" mat-icon-button color="white">
											<mat-icon (click)="filterItems(intro)">search</mat-icon>
										</button>
									</span>
								</mat-form-field>
							</div>


							<ng-container *ngFor="let item of (intro.filteredItems ? intro.filteredItems : intro.items)">
								<li class="list-group-item item-details" [class.border-warning]="item.discontinued == 1 || item.discontinued === '1'">
									<div class="item-details-row">
										<div class="item-description">
											<p>{{ item.stockid }} <span *ngIf="item.discontinued == 1 || item.discontinued === '1'" class="badge bg-danger ms-1">DC</span> <span *ngIf="config.liveinventory && item.qoh?.quantity != null" class="mat-elevation-z1 qoh-label">{{ item.qoh.quantity }} <span>qoh</span></span></p>
											<p>{{ item.description }}</p>
										</div>
										<div class="item-quantity">
											<button mat-icon-button (click)="decrementmm(item, intro)">
												<mat-icon>remove</mat-icon>
											</button>
											<input matInput type="text" class="quantity-input" value="{{ item.quantity | number }}" (input)="qtyMM($event, item, intro)">
											<button mat-icon-button (click)="incrementmm(item, intro)">
												<mat-icon>add</mat-icon>
											</button>
										</div>
									</div>
								</li>
							</ng-container>
							</mat-expansion-panel>
						</mat-accordion>
						</div>
					</ng-container>
				</div>
			</div>

	</div>
	<div [ngClass]="{'d-none': !mmSidePanel, 'col-12 col-lg-7 m-0 p-0 sidepanel mm-sidepanel mm-sidepanel--substituting': mmSidePanel && showSubstitution, 'col-lg-3 m-0 p-0 sidepanel mm-sidepanel': mmSidePanel && !showSubstitution}">
		<div class="mm-progress-row" [ngClass]="{'mm_completed': mm_progress.complete}" *ngIf="mm_progress">
			<div class="text-center font-weight-lighter mm-progress-row__label">Selections</div>
			<!-- <ng-container>
				<div class="m-0 p-0 row w-100 font-weight-lighter">
					<div class="col-6 m-0 p-0 text-left">
						Qty
					</div>
					<div class="col-6 m-0 p-0 text-right">
						{{mm_progress.added}} / {{mm_progress.total}}
					</div>
				</div>
				<mat-progress-bar mode="determinate" value="{{mm_progress.percent}}"></mat-progress-bar>
			</ng-container> -->
		</div>
		<div class="mm-sub-btn-wrap" *ngIf="allow_mm_substitutes">
			<button type="button" class="w-100 sub-btn" mat-stroked-button color="primary" (click)="showSubstitution = !showSubstitution">
				<ng-container *ngIf="!showSubstitution">
					Substitute Item?
				</ng-container>
				<ng-container *ngIf="showSubstitution">
					Substituting...
				</ng-container>
			</button>
		</div>
		<div class="substituion-block mm-substitution-block" *ngIf="showSubstitution">
			<h5 class="mm-substitution-block__title">Substitute with
				<mat-icon *ngIf="substituteItem" class="mm-substitution-block__check text-success">check_circle</mat-icon>
			</h5>
			<mat-form-field class="mb-1 w-100" appearance="outline" *ngIf="!substituteItem">
				<input placeholder="Scan barcode or enter SKU" matInput type="text" [formControl]="mmSubstituteRef">
				<svg *ngIf="subsearch" class="spinner subsearch" width="25px" height="25px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
			</mat-form-field>

			<div *ngIf="substituteItemList.length && !substituteItem" class="mm-sub-pick-scroll">
				<div class="mm-sub-pick-list" role="list">
					<div *ngFor="let item of substituteItemList" class="mm-sub-pick-row" role="listitem">
						<div class="mm-sub-pick-info">
							<span class="mm-sub-pick-sku">{{ item.stockid }}</span>
							<span class="mm-sub-pick-desc">{{ item.description }}</span>
						</div>
						<button type="button" mat-stroked-button color="primary" class="mm-sub-pick-btn" (click)="substituteItem = item">Select</button>
					</div>
				</div>
			</div>
			<div class="mm-sub-picked-card item-block subitem" *ngIf="substituteItem">
				<div class="mm-sub-picked-card__head">
					<b class="mm-sub-picked-card__sku">{{substituteItem.stockid}}</b>
					<button type="button" mat-icon-button class="text-danger mm-sub-picked-card__remove" (click)="substituteItem = false" aria-label="Remove substitute">
						<mat-icon>delete</mat-icon>
					</button>
				</div>
				<div class="mm-sub-picked-card__desc">{{substituteItem.description}}</div>
			</div>

			<h5 class="mm-substitution-block__title">Apply to group
				<mat-icon *ngIf="mmSubstituteGroupRef.value" class="mm-substitution-block__check text-success">check_circle</mat-icon>
			</h5>
			<mat-button-toggle-group class="m-auto mb-1 d-flex intro-sub-select" name="Intro" aria-label="Intro Selector" [formControl]="mmSubstituteGroupRef">
				<ng-container *ngFor="let int of promo.intros">
					<mat-button-toggle *ngIf="int.mmid" value="{{int.name}}">{{int.name}}</mat-button-toggle>
				</ng-container>
			</mat-button-toggle-group>

			<button type="button" mat-raised-button color="accent" (click)="getSub(mmSubstituteGroupRef.value)" class="w-100 mt-2" [disabled]="!mmSubstituteGroupRef.value || !substituteItem">
				Add Substitution
			</button>

		</div>

		<div class="selected-panel">
			<div class="ov-auto mm-selected-scroll">
				<ng-container *ngFor="let item of mm_items_selected">
					<div *ngIf="item.quantity > 0" class="mm-selected-line item-block mat-elevation-z2" [ngClass]="{'opacity-dim' : showSubstitution, 'substitute-indicator' : item.substitute}">
						<div class="mm-selected-line__row">
							<div class="mm-selected-line__text">
								<span class="mm-selected-line__sku">{{item.stockid}}</span>
								<span class="mm-selected-line__desc">{{item.description}}</span>
							</div>
							<div class="mm-selected-line__qty-controls">
								<button type="button" mat-icon-button class="mm-qty-btn" (click)="setter(item, item.quantity - 1)">
									<mat-icon>remove</mat-icon>
								</button>
								<input type="text" class="mm-qty-input" [value]="item.quantity" (change)="setter(item, +$event.target.value || 0)">
								<button type="button" mat-icon-button class="mm-qty-btn" (click)="setter(item, 1, true)">
									<mat-icon>add</mat-icon>
								</button>
							</div>
						</div>
						<div class="mm-selected-line__actions">
							<button type="button" class="btn-small text-danger" mat-stroked-button (click)="setter(item, 0)">Remove</button>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
</ng-template>
<ng-template #edumodal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ event.name }} Registration - {{ event.location_name }} - {{ event.date }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
			<div class="row">
			<div class="col-12">
			{{ event.short_description }}
			</div>
			</div>
			<br>
			<div class="row">
			<div class="col-3">
			<b>Host</b>
			</div>
			<div class="col-3">
			{{ event.host }}
			</div>
			<div class="col-3">
			<b>Presenter</b>
			</div>
			<div class="col-3">
			{{ event.artist_name }}
			</div>
			</div>
			<hr>
			<div class="row">
			<div class="col-3">
			<b>Cost Per Seat</b>
			</div>
			<div class="col-3">
			{{ event.discount | currency }}
			</div>
			<div class="col-3">
			<b>Capacity Remaining</b>
			</div>
			<div class="col-3">
			{{ event.remaining }} / {{ event.uses_total }}
			</div>
			</div>
			<hr>
	<form [formGroup]="regForm">
		<div class="row">

			<div class="col-2">
			<mat-form-field>
			<mat-label>Name</mat-label>
			<input matInput type="text" formControlName="eduname">
			</mat-form-field>
			</div>
			<div class="col-2">
			<mat-form-field>
			<mat-label>Cell Phone</mat-label>
			<input matInput type="text" formControlName="educell">
			</mat-form-field>
			</div>
			<div class="col-2">
			<mat-form-field>
			<mat-label>Email</mat-label>
			<input matInput type="text" formControlName="eduemail">
			</mat-form-field>
			</div>
			<div class="col-2">
			<mat-form-field>
			<mat-label>Instagram</mat-label>
			<input matInput type="text" formControlName="eduinsta">
			</mat-form-field>
			</div>
			<div class="col-2">
			<button type="button" mat-stroked-button aria-label="Add" (click)="addSeat(event)" [disabled]="!regForm.valid"><mat-icon>add</mat-icon> Add Seat</button>
			</div>

		</div>
	</form>
		<hr>
		<div class="row" *ngFor="let seat of event.seats">
			<div class="col-2">
			{{ seat.name }}
			</div>
			<div class="col-2">
			{{ seat.cell }}
			</div>
			<div class="col-2">
			{{ seat.email }}
			</div>
			<div class="col-2">
			{{ seat.insta }}
			</div>
			<div class="col-2">
			<button type="button" mat-stroked-button aria-label="Add" (click)="remSeat(seat)"><mat-icon>remove</mat-icon></button>
			</div>
		</div>
		<span *ngIf="loyaltylist.length"><h3> Loyalty Programs </h3></span>
		<form formGroup="eduReward">
		<div class="row" *ngFor="let r of loyaltylist">
			<div class="col-4">
				{{r.name}}
			</div>
			<div class="col-4">
				<mat-form-field *ngIf="r.type == 2">
					<mat-label>{{r.text}}</mat-label>
					<input matInput formControlName="additional-{{r.id}}" />
				</mat-form-field>
			</div>
			<div class="col-4">
				<mat-form-field>
					<mat-label>$ Amount</mat-label>
					<input matInput formControlName="amount-{{r.id}}" />
				</mat-form-field>
			</div>

		</div>
		</form>
	</div>
	<div class="modal-footer">
		<h4 class="modal-title">Total: {{ event.total | currency}}</h4>
		<button type="button" mat-stroked-button aria-label="Add" (click)="addedureg(event)" [disabled]="!event.seats.length"><mat-icon>add</mat-icon> Add To Order</button>
	</div>
</ng-template>
<div [ngClass]="isGridView ? '' : 'list-layout'">

	<ng-container *ngIf="isGridView">
		<div class="row">
			<ng-container *ngFor="let item of filtered_items; let i = index; trackBy: trackByStockId">
				<div class="col-12 col-md-6 col-lg-4">
					<div class="card mb-3">
						<img *ngIf="itemImageSrc(item)" [src]="itemImageSrc(item)" class="card-img-top" [alt]="item.stockid || ''" data-eager>
						<div class="card-body" (click)="openModal(itemdetails, item)">
							<h5 class="card-title">{{ item.brand }}</h5>
							<p class="card-text">{{ item.description }}</p>
							<div *ngIf="config.liveinventory" class="d-flex justify-content-center flex-wrap gap-1 mt-2 compact-pills grid-card-qoh" (click)="$event.stopPropagation()">
								<app-qoh-popover [item]="item">
									<div class="compact-item pointer compact-item--pill">
										<span class="compact-pill-label">QOH</span>
										<span class="compact-pill qoh-pill" [ngClass]="getQohPillClass(item.locqoh)">{{ item.locqoh }}</span>
									</div>
								</app-qoh-popover>
								<ng-container *ngIf="config.env.client !== 'hairlines'">
									<div class="compact-item compact-item--pill">
										<span class="compact-pill-label">COM</span>
										<span class="compact-pill com-pill">{{ item.qos }}</span>
									</div>
									<div class="compact-item compact-item--pill">
										<span class="compact-pill-label">AVAIL</span>
										<span class="compact-pill avail-pill">{{ item.locqoh - item.qos }}</span>
									</div>
								</ng-container>
							</div>
						</div>
						<div class="card-footer text-muted">
							<div class="row p-0 m-0 text-center">
								<div class="col-auto mt-1 ml-auto mr-0 p-0 shrink-2">
									<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm " (click)="decrement(item)">
										<small><i class="material-icons">remove</i></small>
									</button>
								</div>
								<div class="m-0 p-0 the-dense-zone text-center" [ngClass]="filtersOpen ? 'col-4' : 'col-6 mw100'">
									<input type="text" tabindex="{{ i + 2 }}" pattern="[0-9]*" value="{{ item.quantity | number }}" autofocus (input)="updateSearchQuantity($event, item )" class="quantity-input col-auto" [ngClass]="{'quantity-changed': item.quantity > 0}">
								</div>
								<div class="col-auto mt-1 m-0 mr-0 p-0 shrink-2">
									<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm" (click)="increment(item)">
										<small><i class="material-icons">add</i></small>
									</button>
								</div>

								<div class="col-12 col-md-4 col-lg-4 ml-auto mb-0 mt-0 ml-auto mr-auto">
									<div [ngClass]="(item.quantity > 0) ? 'linetotal_row_picked' : 'linetotal_row'" class="row">
										<span class="linetotal_price">
											&nbsp;{{ getLineTotal(item) | currency }} &nbsp;
										</span>
										<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="addToOrder(item)" *ngIf="!item.ispromo && !item.isevent">
											<small><i class="material-icons">add_box</i></small>
										</button>
										<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="triggerEdu(item)" *ngIf="item.isevent">
											<small><i class="material-icons">settings</i></small>
										</button>
										<ng-container *ngIf="item.ispromo">
											<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="triggerMm(item)" *ngIf="item.ispromo.requiresconfig">
												<small><i class="material-icons">settings</i></small>
											</button>
											<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="addPromo(item)" *ngIf="!item.ispromo.requiresconfig">
												<small><i class="material-icons">add_box</i></small>
											</button>
										</ng-container>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</ng-container>
	<ng-container *ngIf="!isGridView">
		<div class="row sortable-header-row mt-0 mb-0 pt-0 pb-0 border-bottom text-center text-md-left d-none d-md-flex">
			<div class="col-auto px-2 d-flex align-items-center justify-content-center salesman-list-thumb-header" aria-hidden="true"></div>
			<div class="col-md-5 col-lg-5 ml-auto mr-auto ml-md-0 mr-md-0 p-0 mt-0 mb-0 d-flex align-items-center">
				<div class="sortable-header-cell mr-4 pointer" (click)="sortItems('brand')">
					Brand <mat-icon *ngIf="getSortIcon('brand')" class="icon-sm">{{getSortIcon('brand')}}</mat-icon>
				</div>
				<div class="sortable-header-cell mr-4 pointer" (click)="sortItems('stockid')">
					Stock ID <mat-icon *ngIf="getSortIcon('stockid')" class="icon-sm">{{getSortIcon('stockid')}}</mat-icon>
				</div>
				<div class="sortable-header-cell pointer" (click)="sortItems('description')">
					Description <mat-icon *ngIf="getSortIcon('description')" class="icon-sm">{{getSortIcon('description')}}</mat-icon>
				</div>
			</div>
			<div class="col-12 col-sm-1 col-md-1 col-lg-1 ml-auto mr-auto mr-md-0"></div>
			<div class="col-12 col-md-3 mt-0 ml-auto mr-auto"></div>
			<div class="col-6 col-md-2 col-lg-1 ml-auto mb-0 mt-0 ml-auto mr-auto d-flex align-items-center justify-content-center">
				<div class="sortable-header-cell pointer" (click)="sortItems('price')">
					Price <mat-icon *ngIf="getSortIcon('price')" class="icon-sm">{{getSortIcon('price')}}</mat-icon>
				</div>
			</div>
		</div>
		<ng-container *ngFor="let item of filtered_items; let i = index; trackBy: trackByStockId">
			<div class="row mt-0 mb-2 mb-lg-0 pt-0 pb-0 border-top text-center text-md-left compact-row">
				<div class="col-auto px-2 d-flex align-items-center justify-content-center salesman-list-thumb-col">
					<div class="salesman-list-thumb-wrap" [class.salesman-list-thumb-wrap--empty]="!itemImageSrc(item)">
						<img *ngIf="itemImageSrc(item)" [src]="itemImageSrc(item)" class="salesman-list-thumb-img" [alt]="item.stockid || ''" data-eager>
					</div>
				</div>
				<div class="col-md-5 col-lg-5 ml-auto mr-auto ml-md-0 mr-md-0 p-0 mt-0 mb-0 salesman-list-desc">
					<span class="bold pointer" (click)="openModal(itemdetails, item)">
						<span class="description">{{item.brand}} |&nbsp;</span> <span class="stock-id">{{ item.stockid }} |&nbsp;</span> <span class="brand">{{ item.description }}</span>
					</span>
				</div>
				<div *ngIf="config.liveinventory" class="col-md-2 col-lg-1 mt-0 p-0 text-center compact-info" [ngClass]="filtersOpen ? 'col-xl-1' : ''">
					<div class="d-flex justify-content-between align-items-center flex-fill compact-pills">
						<app-qoh-popover [item]="item">
							<div class="compact-item pointer compact-item--pill">
								<span class="compact-pill-label">QOH</span>
								<span class="compact-pill qoh-pill" [ngClass]="getQohPillClass(item.locqoh)">{{ item.locqoh }}</span>
							</div>
						</app-qoh-popover>
						<ng-container *ngIf="config.env.client !== 'hairlines'">
							<div class="compact-item compact-item--pill">
								<span class="compact-pill-label">COM</span>
								<span class="compact-pill com-pill">{{ item.qos }}</span>
							</div>
							<div class="compact-item compact-item--pill">
								<span class="compact-pill-label">AVAIL</span>
								<span class="compact-pill avail-pill">{{ item.locqoh - item.qos }}</span>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="col-12 col-sm-1 col-md-1 col-lg-1 ml-auto mr-auto mr-md-0 showqtys d-flex align-items-center justify-content-center salesman-special-slot">
					<div
						*ngIf="issalesman && item.specialflag"
						class="salesman-special-star"
						matTooltip="Special pricing"
						matTooltipPosition="above">
						<mat-icon aria-hidden="true">star</mat-icon>
					</div>
				</div>
				<div class="col-12 col-md-3 mt-0 ml-auto mr-auto">
					<div class="row p-0 m-0 text-center">
						<div class="col-auto mt-1 ml-auto mr-0 p-0 shrink-2">
							<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm " (click)="decrement(item)">
								<small><i class="material-icons">remove</i></small>
							</button>
						</div>
						<div class="m-0 p-0 the-dense-zone text-center" [ngClass]="filtersOpen ? 'col-4' : 'col-6 mw100'">
							<input type="text" tabindex="{{ i + 2 }}" pattern="[0-9]*" value="{{ item.quantity | number }}" autofocus (input)="updateSearchQuantity($event, item )" class="quantity-input col-auto" [ngClass]="{'quantity-changed': item.quantity > 0}">
						</div>
						<div class="col-auto mt-1 m-0 mr-0 p-0 shrink-2">
							<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm" (click)="increment(item)">
								<small><i class="material-icons">add</i></small>
							</button>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-2 col-lg-1 ml-auto mb-0 mt-0 ml-auto mr-auto">
					<div [ngClass]="(item.quantity > 0) ? 'linetotal_row_picked' : 'linetotal_row'" class="row">
						<span class="linetotal_price">
							&nbsp;{{ getLineTotal(item) | currency }} &nbsp;
						</span>
						<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="addToOrder(item)" *ngIf="!item.ispromo && !item.isevent">
							<small><i class="material-icons">add_box</i></small>
						</button>
						<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="triggerEdu(item)" *ngIf="item.isevent">
							<small><i class="material-icons">settings</i></small>
						</button>
						<ng-container *ngIf="item.ispromo">
							<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="triggerMm(item)" *ngIf="item.ispromo.requiresconfig">
								<small><i class="material-icons">settings</i></small>
							</button>
							<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="addPromo(item)" *ngIf="!item.ispromo.requiresconfig">
								<small><i class="material-icons">add_box</i></small>
							</button>
						</ng-container>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
</div>
